"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TO_CALLS_VERSION = exports.LATEST_VERSION = exports.KNOWN_VERSIONS = void 0;
exports.KNOWN_VERSIONS = [15, 14, 13, 12, 11, 10, 9];
exports.LATEST_VERSION = exports.KNOWN_VERSIONS[0];
exports.TO_CALLS_VERSION = 14; // LATEST_VERSION;
